export const currencyFormat = (data, places = 0, symbol = '$') => {
  //return '$' + data.toFixed(places).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  if (data) return symbol + data.toLocaleString("en-US");else return '-----';
};
export default currencyFormat;